<template>
	<div class="model-key">
		<!-- 搜索栏 -->
		<div class="search-bar">
			<div class="search-left">
				<el-select v-model="shareType" placeholder="共享类型" style="width: 160px; margin-right: 10px;" @change="fetchData">
					<el-option label="我共享的" value="my"></el-option>
					<el-option label="机构共享给我的" value="org"></el-option>
				</el-select>
				<el-input v-model="queryParams.keyName" placeholder="密钥名称" style="width: 200px; margin-right: 10px;" clearable></el-input>
				<el-select v-model="queryParams.modelTypeId" placeholder="模型类型" style="width: 200px; margin-right: 10px;" clearable>
					<el-option v-for="item in modelTypeList" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
				</el-select>
				<el-button type="primary" icon="el-icon-search" @click="fetchData">搜索</el-button>
			</div>

		</div>

		<!-- 数据表格 -->
		<el-table :data="tableData" border style="width: 100%; margin-top: 20px;">
			<el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
			<el-table-column prop="platform" label="平台" width="120" align="center"></el-table-column>
			<el-table-column prop="keyName" label="密钥名称" width="180"  align="center"></el-table-column>
			<el-table-column prop="keyRequestName" label="请求名" width="150" align="center"></el-table-column>
			<el-table-column prop="keyValue" label="密钥" width="200" show-overflow-tooltip align="center">
				<template slot-scope="scope">
					{{ scope.row.keyValue}}
				</template>
			</el-table-column>
			<!-- <el-table-column prop="modelTypeName" label="模型类型" width="120"></el-table-column> -->
			<el-table-column prop="expireTime" label="过期时间" width="180" align="center"></el-table-column>
			<el-table-column prop="status" label="状态" width="100" align="center">
				<template slot-scope="scope">
					<el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
						{{ scope.row.status === 0 ? '启用' : '禁用' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作"  width="250" align="center">
				<template slot-scope="scope">
					<div v-if="shareType=='my'">
					<el-button v-if="scope.row.shareOrg==0" size="mini" @click="postModelKeySetShare(scope.row,1)">共享</el-button>
					<el-button v-if="scope.row.shareOrg==1" size="mini" @click="postModelKeySetShare(scope.row,0)">取消共享</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="queryParams.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"
			style="margin-top: 20px; text-align: right;">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'ModelKey',
	data() {
		return {
			tableData: [],
			total: 0,
			modelTypeList: [],
			// 下拉选中项，默认 我共享的
			shareType: 'my',
			queryParams: {
				pageNum: 1,
				pageSize: 10,
				keyName: '',
				modelTypeId: null
			},
			dialogVisible: false,
			dialogTitle: '',
			form: {
				id: null,
				platform: '',
				keyName: '',
				keyRequestName: '',
				keyValue: '',
				modelTypeId: null,
				expireTime: '',
				status: 0,
				providerCode: '',
			},
			keyForm: {
				id: null,
				keyValue: '',
				expireTime: '',
				keyName: '',
			},
			iskeyForm: false,
			rules: {
				keyName: [{
					required: true,
					message: '请输入密钥名称',
					trigger: 'blur'
				}],
				keyValue: [{
					required: true,
					message: '请输入密钥Key',
					trigger: 'blur',
					validator: (rule, value, callback) => {
						if (this.form.id) {
							callback();
						} else if (!value) {
							callback(new Error('请输入密钥Key'));
						} else {
							callback();
						}
					}
				}],
				modelTypeId: [{
					required: true,
					message: '请选择模型类型',
					trigger: 'change'
				}],
			},
			userType: localStorage.getItem('userType'),
		}
	},
	created() {
		this.forType()
	},
	methods: {
		async forType(){
			try {
				const res = await this.API.get(this.API.admin.getModelTypeList, {
					pageNum: 1,
					pageSize: 100
				})
				let  list= res.data.data.records || []
				// if(list.lenght>0){
					this.modelTypeList=list?.filter(v=>v.authType==0)
				// }
				// this.modelTypeList=[]
			} catch (e) {
				this.modelTypeList=[]
			}
		},
		// 根据下拉类型切换接口查询
		async fetchData() {
			try {
				let res;
				// 默认查 我共享的
				if (this.shareType === 'my') {
					res = await this.API.get(this.API.admin.getModelKeyMyShareList, this.queryParams)
				} else {
					// 机构共享给我的
					res = await this.API.get(this.API.admin.getModelKeyOrgShareList, this.queryParams)
				}
				this.tableData = res.data.data || []
				this.total = res.data.data.length || 0
			} catch (e) {}
		},

		// 设置共享/取消共享
		postModelKeySetShare(row, value) {
			let formData = new FormData();
			formData.append("id", row.id);
			formData.append("shareOrg", value);
			this.API.post(this.API.admin.postModelKeySetShare, formData).then(res => {
				this.fetchData()
				this.$message.success('修改共享成功')
			}).catch(error => {
				this.$message.error('修改共享失败')
			})
		},
		// 分页
		handleSizeChange(val) {
			this.queryParams.pageSize = val
			this.fetchData()
		},
		handleCurrentChange(val) {
			this.queryParams.pageNum = val
			this.fetchData()
		}
	},
	mounted() {
		// this.fetchModelTypeList()
		this.fetchData()
	}
}
</script>

<style scoped>
.model-key {
	padding: 20px;
	background-color: #fff;
}

.search-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.search-left {
	display: flex;
	align-items: center;
}
</style>